const quickLinks = [
  { label: "热门排行", href: "#ranking" },
  { label: "精选合集", href: "#collections" },
  { label: "内容探索", href: "#explore" },
  { label: "优质创作者", href: "#creators" },
  { label: "热门标签", href: "#tags" },
  { label: "观看指南", href: "#guide" },
];

const themeLinks = [
  { label: "美食合集", href: "#collections" },
  { label: "旅行合集", href: "#collections" },
  { label: "萌宠合集", href: "#collections" },
  { label: "手工合集", href: "#collections" },
  { label: "数码合集", href: "#collections" },
  { label: "城市漫游", href: "#collections" },
];

export default function Footer() {
  return (
    <footer className="w-full bg-secondary-950 text-background-100">
      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 gap-10 px-4 py-14 md:grid-cols-[1.4fr_1fr_1fr] md:px-6">
        <div>
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-play-fill text-lg"></i>
            </span>
            <span className="font-heading text-lg font-bold text-background-50">小视频</span>
          </div>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-100/70">
            聚合当下热门的小视频合集与精选排行，持续更新推荐榜单与内容大全，帮你快速定位值得观看的精彩视频。
          </p>
          <div className="mt-5 flex flex-wrap gap-2">
            {["每日精选", "热门排行", "内容大全"].map((chip) => (
              <span
                key={chip}
                className="rounded-full border border-background-100/20 px-3 py-1 text-xs font-medium text-background-100/80"
              >
                {chip}
              </span>
            ))}
          </div>
        </div>

        <div>
          <h3 className="font-heading text-sm font-bold text-background-50">站内导航</h3>
          <ul className="mt-4 flex flex-col gap-3">
            {quickLinks.map((link) => (
              <li key={link.label}>
                <a
                  href={link.href}
                  className="cursor-pointer text-sm text-background-100/70 transition-colors hover:text-primary-300"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-heading text-sm font-bold text-background-50">热门主题</h3>
          <ul className="mt-4 flex flex-col gap-3">
            {themeLinks.map((link) => (
              <li key={link.label}>
                <a
                  href={link.href}
                  className="cursor-pointer text-sm text-background-100/70 transition-colors hover:text-primary-300"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-background-100/10">
        <div className="mx-auto flex w-full max-w-6xl flex-col items-center justify-between gap-3 px-4 py-6 text-center md:flex-row md:px-6 md:text-left">
          <p className="text-xs text-background-100/60">
            © 2026 小视频 · 本页为内容浏览与推荐展示，不提供下载与账号服务。
          </p>
          <p className="text-xs text-background-100/60">
            筛选与搜索仅作用于本页内容，不采集个人数据。
          </p>
        </div>
      </div>
    </footer>
  );
}